import type { FaireProductEntity } from "../../entity_types/product";

export const p_c42kdcn7kq: FaireProductEntity = {
  token: "p_c42kdcn7kq",
  type: "product",
  name: "jotter pen",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/1ca126bab61143fa89a4beac608be5466f5e5a4a3a80bd5120e25ac26d956604.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3df37bb09d356e73f1797e2c62d7092075cbe95961e28dc9ca49c4ce2ad1467.jpeg",
    "https://cdn.faire.com/fastly/087500ba0c1e05890829c6e5f27bb2dcb267b98da95d85b0c8b927d86c18f20d.jpeg",
    "https://cdn.faire.com/fastly/a00c89cfa68fd3abc201b649e270ca30cf48a122bad9b4c4f178c7fc22862de3.jpeg",
    "https://cdn.faire.com/fastly/5a2c5abd4eec1160ab1b95afe09caecde6d51801855df4755a55e168cf7143f0.jpeg",
    "https://cdn.faire.com/fastly/be0b68ab4ce4206c7b81d648e86f7738b10a354a3fcac3e2cf86c15908121a86.jpeg",
    "https://cdn.faire.com/fastly/e9fbf97f173fa0748c40585e47f9670fd0a6c361df1ed6c2c693d1343e807643.jpeg",
    "https://cdn.faire.com/fastly/4e4dd4cdeb7c8d19ca7fd8369af8fda03604bc876bc8c426d8be9f7d1d7cd0b2.jpeg",
    "https://cdn.faire.com/fastly/100eaa7cfa494daf69337eb625b4c20097f7220e2333d7980520560862bec405.jpeg",
    "https://cdn.faire.com/fastly/92914c110b51901d2bd33fb81308c2e0a54ae5f86c5fe41c685e392adb09aa31.jpeg",
    "https://cdn.faire.com/fastly/fdcd8ad20af9b95b80865b8e2a16f44126ea21d5c2d0db975b654afaa54a3cc9.jpeg",
    "https://cdn.faire.com/fastly/4d53c36746fd1ee3f1f121cbb60c61a43b6f04c5bc346482ecde407960a37a9b.jpeg",
    "https://cdn.faire.com/fastly/699ea404a20404d30caa1a2d35a75bf80d38e047c8c8f35cd929ce12223dc3d2.jpeg",
    "https://cdn.faire.com/fastly/03151b4e904aa137188259781d88f56879633307438fd1fe7b8b96bd8daf9cd2.jpeg",
    "https://cdn.faire.com/fastly/33a9c9e33b6a1c6202b0ca93b82206a452efcd0fcc38168e83fc325fd36926f2.jpeg",
    "https://cdn.faire.com/fastly/4ca12ee90c9da5a33733e12c1b04cbd4143762cf93ba22a28ee3f5ad472bccef.jpeg",
    "https://cdn.faire.com/fastly/0975975ea28de22c93081f7158de8b14b4e4b0465f25b2e4fc9f3e214367be88.jpeg",
    "https://cdn.faire.com/fastly/b7d6fcb5bd7d60306790738044b7fb69dd7ada17d960c84b7f1b2ec3d460f050.jpeg",
    "https://cdn.faire.com/fastly/a292deaecb55856016c5e12aac687f78597b0abdf73a2b3cff2d96e7b145b804.jpeg",
  ],
  priceDollars: 4.5,
  description:
    'This pen will make your writing better (for real! It\'s what everyone says when they try it!).\n\nJotter pen with a handwritten sentiment on the side. Matte finish for easy gripping. Smooth black gel ink for seamless writing. \n\nDetails:\n\n\n * single jotter pen\n\n * black gel ink makes writing feel smooth\n\n * encouraging sentiment in Emily\'s handwriting\n\n * Sangria reads "flourish" \n * Pink reads "love" \n * Camel reads "grateful" \n * Light blue reads "celebrate" \n * Royal blue reads "enjoy" \n * Navy blue reads "abide" \n * Teal reads "create" \n * Olive green reads "delight" ',
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:08.254Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
